import { SVGProps, Ref, forwardRef } from 'react';

export const LocationFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.302 4.951 7.294 9.241c-4.03 1.727-6.045 2.59-5.958 3.9s2.198 1.902 6.42 3.085l6.264 1.754 1.755 6.264c1.182 4.222 1.773 6.333 3.083 6.42s2.174-1.929 3.901-5.958l4.29-10.008c3.096-7.225 4.644-10.838 2.867-12.615-1.776-1.776-5.389-.228-12.614 2.868"
                fill="currentColor"
            />
        </g>
    </svg>
));
LocationFilledSize32Glyph.displayName = 'LocationFilledSize32Glyph';
